import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrRequestShowingButton from 'client/components/SrRequestShowingButton';

const SrListingJoinWaitlist = ({ listing, preLease }) => {
  return (
    <div>
      <div className="titleContainer">
        <span className="title">home coming soon</span>
      </div>
      <SrBox marginBottom="16px">
        <SrText>
          This home is not yet available for tours. To be one of the first to view the home, join
          the waitlist below and we will notify you once you can visit. You can still Apply to this
          home above!
        </SrText>
      </SrBox>
      <SrRequestShowingButton listing={listing} preLease={preLease} />
    </div>
  );
};

SrListingJoinWaitlist.propTypes = {
  listing: PropTypes.object.isRequired,
  preLease: PropTypes.object.isRequired,
};

SrListingJoinWaitlist.displayName = 'SrListingJoinWaitlist';

export default SrListingJoinWaitlist;
